"use strict";

exports.__esModule = true;
exports.resolveLabelHeight = exports.MeasurementValue = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _MeasurementValue = require("./MeasurementValue.legacy");
exports.resolveLabelHeight = _MeasurementValue.resolveLabelHeight;
var _MeasurementValue2 = require("./MeasurementValue.modern");
// Flag-gated UI: `MeasurementValue.legacy` is the component as it is on master,
// `MeasurementValue.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var MeasurementValue = exports.MeasurementValue = (0, _uiSwitch.uiSwitch)(_MeasurementValue.MeasurementValue, _MeasurementValue2.MeasurementValue, "MeasurementValue");